import React from 'react';
import { connect } from 'react-redux';
import {Button,Paper,Divider,CssBaseline,TextField,Link,Grid,Box,Typography,Container
,FormControl,InputLabel,Select,FormHelperText,Hidden} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { withStyles } from "@material-ui/core/styles";
import { Helmet } from "react-helmet";
import { Formik } from "formik";
import * as Yup from "yup";
import {NavLink as RouterLink} from 'react-router-dom';
import { history } from "../../../components/helpers/History";
import {DoctorAction} from '../../../redux/actions/DoctorAction';
import { AppConstants } from "../../../components/constants/ApplicationConstants";

const useStyles = (theme) => ({
  paper: {
    marginTop: theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
    backgroundColor: '#fff',
    padding : theme.spacing(4),
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  typography: {
    margin: theme.spacing(3),
  },divider:{
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3)
  },buttons: {
    display: 'flex',
    justifyContent: 'center',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
});

class AdminProfile extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
          user: {
              id:this.props.insInfo && this.props.insInfo.id,
              primaryInsurer: this.props.insInfo && this.props.insInfo.primaryHealthInsurer?this.props.insInfo.primaryHealthInsurer:'',
              primaryInsurerId: this.props.insInfo && this.props.insInfo.primaryHealthInsurerId?this.props.insInfo.primaryHealthInsurerId:'',
              secondaryInsurer: this.props.insInfo && this.props.insInfo.secondaryHealthInsurer?this.props.insInfo.secondaryHealthInsurer:'',
              secondaryInsurerId : this.props.insInfo && this.props.insInfo.secondaryHealthInsurerId?this.props.insInfo.secondaryHealthInsurerId:'',
              emrContactName : this.props.insInfo && this.props.insInfo.emgrContName?this.props.insInfo.emgrContName:'',
              emrContactNo : this.props.insInfo && this.props.insInfo.emgrContPhone?this.props.insInfo.emgrContPhone:'',
              emrRelationShip : this.props.insInfo && this.props.insInfo.emgrContRelation ? this.props.insInfo.emgrContRelation : '',
          },
          submitted: false
      };
      
  }
  

  render(){
    const classes = this.props.classes;
    const { registering  } = this.props;
    const { user, submitted } = this.state;
    return (
      <>
        
        <Container component="main" maxWidth="md">
        <CssBaseline />
        <Paper className={classes.paper}>
            <Formik enableReinitialize
              initialValues={{
                id:this.state.user.id,
                primaryInsurer: this.state.user.primaryInsurer,
                primaryInsurerId: this.state.user.primaryInsurerId,
                secondaryInsurer : this.state.user.secondaryInsurer,
                secondaryInsurerId : this.state.user.secondaryInsurerId,
                emrContactName : this.state.user.emrContactName,
                emrContactNo : this.state.user.emrContactNo,
                emrRelationShip : this.state.user.emrRelationShip
              }}

              validationSchema={Yup.object().shape({
                primaryInsurer: Yup.string()
                  .max(100)
                  .required("Primary Insurer is required"),
                primaryInsurerId: Yup.string()
                  .max(30)
                  .required("Primary Insurer Id is required"),
                secondaryInsurer: Yup.string()
                  .max(100,"Secondary Insurer shuld be lessthan 100 charactor"),
                secondaryInsurerId: Yup.string()
                .max(30,"Secondary Insurer Id shuld be lessthan 100 charactor"),
                emrContactName: Yup.string()
                .max(30)
                .required("Emergency Contact is required"),
                emrContactNo: Yup.string()
                .max(30)
                .required("Emergency Contact Number is required"),
                emrRelationShip: Yup.string()
                .max(30)
                .required("Emergency contact relationship is required"),


                 
                })
              }
                
              
                onSubmit={(values, { setSubmitting }) => {
                  this.setState({ submitted: true });
                  //this.props.submit(values);
                  console.log(values);
                  this.props.updateInsurerInfo(values);
                }}
            >
              {({
                errors,
                handleBlur,
                handleChange,
                handleSubmit,
                touched,
                values,
              }) => (
                <form onSubmit={handleSubmit} className={classes.form}
                noValidate
                name="form"> 
                  <Box sx={{ mb: 3 }}>
                  <Typography component="h3" variant="body1">
                      Insurance and emergency info
                    </Typography>
                  </Box>
                  <Grid container spacing={1}>
                  
                    <Grid item xs={12} sm={6}>
                      <TextField
                          error={Boolean(touched.primaryInsurer && errors.primaryInsurer)}
                          fullWidth
                          helperText={touched.primaryInsurer && errors.primaryInsurer}
                          label="Primary Insurer"
                          margin="normal"
                          name="primaryInsurer"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.primaryInsurer}
                          variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                          error={Boolean(touched.primaryInsurerId && errors.primaryInsurerId)}
                          fullWidth
                          helperText={touched.primaryInsurerId && errors.primaryInsurerId}
                          label="Primary Insurer Id"
                          margin="normal"
                          name="primaryInsurerId"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.primaryInsurerId}
                          variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                          error={Boolean(touched.secondaryInsurer && errors.secondaryInsurer)}
                          fullWidth
                          helperText={touched.secondaryInsurer && errors.secondaryInsurer}
                          label="Secondary Insurer"
                          margin="normal"
                          name="secondaryInsurer"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.secondaryInsurer}
                          variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                          error={Boolean(touched.secondaryInsurerId && errors.secondaryInsurerId)}
                          fullWidth
                          helperText={touched.secondaryInsurerId && errors.secondaryInsurerId}
                          label="Secondary Insurer Id"
                          margin="normal"
                          name="secondaryInsurerId"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.secondaryInsurerId}
                          variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                    <TextField
                          error={Boolean(touched.emrContactName && errors.emrContactName)}
                          fullWidth
                          helperText={touched.emrContactName && errors.emrContactName}
                          label="Emergency Contact Name"
                          margin="normal"
                          name="emrContactName"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.emrContactName}
                          variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                    <TextField
                          error={Boolean(touched.emrContactNo && errors.emrContactNo)}
                          fullWidth
                          helperText={touched.emrContactNo && errors.emrContactNo}
                          label="Emergency Contact Number"
                          margin="normal"
                          name="emrContactNo"
                          onBlur={handleBlur}
                          onChange={handleChange}
                          value={values.emrContactNo}
                          variant="outlined"
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl
                        variant="outlined"
                        margin="normal"
                        className={classes.formControl}
                        fullWidth
                      >
                        <InputLabel htmlFor="emrRelationShip-label">Emergency Contact Relationship</InputLabel>
                        <Select
                          native
                          value={values.emrRelationShip}
                          error={Boolean(touched.emrRelationShip && errors.emrRelationShip)}
                          helperText={touched.emrRelationShip && errors.emrRelationShip}
                          label="Emergency Contact Relationship"
                          inputProps={{
                            name: "emrRelationShip",
                            id: "emrRelationShip-label",
                          }}
                          onBlur={handleBlur}
                          onChange={handleChange}
                        >
                          <option aria-label="None" value="" />
                          {AppConstants.PATIENT_RELATION_SHIP_LIST.map((element) => {
                              return(<option value={element.value}>
                                {element.label}
                              </option>)
                            })}
                        </Select>
                        {errors.status && touched.status && (
                          <FormHelperText style={{ color: "#f44336" }}>
                            {errors.status}
                          </FormHelperText>
                        )}
                      </FormControl>
                    </Grid>
                  </Grid>
                  
                  
                  <div className={classes.buttons}>
                  <Button
                      variant="contained"
                      color="default"
                      className={classes.button}
                      onClick={()=>{history.goBack();}}
                      >
                          Cancel
                      </Button>

                    <Button
                      type="submit"
                      variant="contained"
                      color="primary"
                      className={classes.button}
                      disabled={this.state.submitted}
                    >
                      Submit
                    </Button>
                    
                  </div>
                  
                </form>
              )}
            </Formik>
            
        </Paper>
        </Container>
      </>
    );
  }
}


function mapStateToProps(state) {
  const  loginUserId  = state.authentication.user.id;
  const profile = state.doctor.profile;
  return { loginUserId , profile};
}

const mapDispatchToProps = (dispatch) => {
  return {
    getUserById: (id) => {
      dispatch(DoctorAction.getDoctorById(id));
    },submit: (value) => {
      dispatch(DoctorAction.updateProfile(value));
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(useStyles,{ withTheme: true })(AdminProfile));